/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_asciiToArray.js
// module id = 1275
// module chunks = 3 4 5 9 15